import {IsArray, IsNumber} from 'class-validator';

export class NotificationCustomReadDto {
  @IsArray()
  @IsNumber({}, {each: true})
  ids!: number[];
}
